module.exports = __webpack_public_path__ + "31064f92bf9423a2682b8acd6bb63275.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/automate_carousel.png
// module id = 558
// module chunks = 0